const BulkFilter = {
    bulkFilterDownload: () => "admin/download/bulk-update",
}
export default BulkFilter
